import styled from 'styled-components';
import { space } from 'styled-system';
export const PopoverBase = styled.div `
  align-items: center;
  display: flex;
  font-family: 'Open Sans', sans-serif;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  line-height: 24px;
  width: 48px;

  & > button:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > button:focus:not(:focus-visible) {
    outline: 0;
  }

  & > button:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > button > i {
    color: var(--color-on-background);
  }

  ${space};
`;
export const Popper = styled.div `
  display: flex;
  background: var(--color-on-background);
  color: var(--color-background);
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  min-width: 288px;
  max-width: 560px;
  padding: 32px;
  z-index: 100;

  & i {
    color: var(--color-background);
  }
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div `
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
`;
export const ButtonWrapper = styled.div `
  margin-top: 1px;
`;
export const Description = styled.div `
  & .system-icon {
    color: var(--color-background);
  }

  & a {
    color: var(--color-background);
  }
`;
